import { Box, Button, Typography, Modal } from '@mui/material';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useToast } from 'use-toast-mui';
import { deleteProgramCategory, deletePrograms, deleteProgramSession } from '../../../api/program';
import { errorMessages } from '../../../utils/methods';

const BodyAskDeleteModal = ({ setOpenAskDelete, openAskDelete, data, mode, dataFunction }) => {
  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '347.92px',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: '20px 30px 20px 30px',
    height: '188px',
    borderRadius: '12.21px',
  };

  const toast = useToast();
  const { user } = useSelector(state => state.user);
  const { t } = useTranslation();

  const handleClose = () => setOpenAskDelete(false);

  const deleteFunction = async () => {
    try {
      if (mode === 'categories') {
        await deleteProgramCategory(data.id, user.token).then(() => {
          dataFunction();
          toast.success(t('success deleted category'));
        });
      } else if (mode === 'programs') {
        await deletePrograms(data.id, user.token).then(() => {
          dataFunction(data.catId);

          toast.success(t('success deleted program'));
        });
      } else if (mode === 'session') {
        await deleteProgramSession(data.id, user.token).then(() => {
          dataFunction(data.proId);
          toast.success(t('success deleted session'));
        });
      }
      handleClose();
    } catch (error) {
      toast.error(errorMessages(error));
    }
  };

  return (
    <div style={{ display: 'flex' }}>
      <Modal
        open={openAskDelete}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box sx={modalStyle}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              paddingTop: '15px',
            }}>
            <Box sx={{ marginBottom: '15px' }}>
              <Typography>{t('Are you sure you want to delete?')}</Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                marginBottom: '20px',
                width: '200px',
                alignItems: 'center',
              }}>
              {mode !== 'session' && (
                <Typography sx={{ textAlign: 'center', color: 'red' }}>
                  {t('If deleted, the corresponding child All sessions will be deleted')}
                </Typography>
              )}
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                width: '210px',
              }}>
              <Button
                sx={{
                  borderRadius: '4.88px',
                  height: '30px',
                  width: '100px',
                  border: '1px solid #0F7F85 ',
                }}
                onClick={handleClose}>
                {t('CANCEL')}
              </Button>
              <Button
                sx={{
                  borderRadius: '4.88px',
                  height: '30px',
                  width: '100px',
                  border: '1px solid #0F7F85 ',
                }}
                variant="contained"
                onClick={() => {
                  deleteFunction();
                }}>
                {t('CONFIRM')}
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default BodyAskDeleteModal;
